import React, { Component } from "react";

import "./ApplicationLoader.scss";

interface ApplicationLoaderProps {
	showLoader: boolean;
}

export default class ApplicationLoader extends Component<ApplicationLoaderProps> {
	[key: string]: any;
	static defaultProps: any;
	static propTypes: any;
	render() {
		if (this.props.showLoader === true) {
			return (
				<div className="applicationLoader">
					<div className="loaderBG" />
				</div>
			);
		} else {
			return null;
		}
	}
}
